/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { useRef, useState } from 'react';
import { ChoicesButton } from './ChoicesButton.jsx';
import { ButtonClear, ButtonStructureLoad, ButtonStructureLoadLocal, ButtonTrajectoryLoad, ButtonMRCLoad } from './ButtonsMolstarManage.jsx'
import { ButtonImportState } from './ButtonsMolstarState.jsx'
import { DisabledSubmitInput } from './LoadButtons.jsx';

export function Loaders(props) {

    const [selectedTypeSource, setSelectedTypeSource] = useState('');
    const [selectedTypeFile, setSelectedTypeFile] = useState('');

    const handleTypeSourceChange = (source) => {
        setSelectedTypeSource(source);

    };
    const handleTypeFileChange = (type) => {
        setSelectedTypeFile(type);

    };
    const [isInputEnabled, setIsInputEnabled] = useState(false);
    const childRef = useRef(null);
    const handleButtonClick = (event) => {
      if (childRef.current) {
        childRef.current.handleSubmission(event);
      }
    };

    return (
        <div>
          <div className="flex md:flex-row flex-col font-roboto max-h-max pb-4 md:space-x-4 space-y-4 text-sm">
            <div className="md:w-1/3 w-full mt-4"><ChoicesButton label='A public database' handle={ handleTypeSourceChange } selected={ selectedTypeSource } value='public' description='import a protein structure from a public database' src='database.svg'/></div>
            <div className="md:w-1/3 w-full"><ChoicesButton label='Your computer' handle={ handleTypeSourceChange } selected={ selectedTypeSource } value='local' description='import a protein structure, a trajectory or a volumetric data from your computer' src='computer.svg'/></div>
            <div className="md:w-1/3 w-full"><ChoicesButton label='A previous project' handle={ handleTypeSourceChange } selected={ selectedTypeSource } value='previousproject' description='import a previously exported project' src='reload.svg'/></div>
          </div>
        
          {selectedTypeSource === 'local' && (
            <div id="tourlocal" className="px-4 rounded-md"> 
            <h3 className="text-md font-semibold whitespace-nowrap dark:text-gray-50">Select a type of data</h3>
            <div className="flex md:flex-row flex-col font-roboto max-h-max md:space-x-4 space-y-4 text-sm justify-center">
              <div className="md:w-1/3 w-full mt-4"><ChoicesButton label='Structure' handle={ handleTypeFileChange } selected={ selectedTypeFile } value='structure' description='import a protein structure in PDB format'/></div>
              <div className="md:w-1/3 w-full"><ChoicesButton label='Trajectory' handle={ handleTypeFileChange } selected={ selectedTypeFile } value='trajectory' description='import a protein trajectory file in DCD or XTC format'/></div>
              <div className="md:w-1/3 w-full"><ChoicesButton label='MRC file' handle={ handleTypeFileChange } selected={ selectedTypeFile } value='mrcfile' description='import a volumetric data in MRC format'/></div>
            </div>
            
            {selectedTypeFile === 'structure' && (
                <div className="font-roboto">
                <ButtonStructureLoadLocal label="Load a structure" plugin={props.plugin} setIsInputEnabled={setIsInputEnabled} ref={childRef} />
                </div>
            )}  
            {selectedTypeFile === 'trajectory' && (
                <div className="font-roboto">
                <ButtonTrajectoryLoad label="Load a trajectory" plugin={props.plugin} setIsInputEnabled={setIsInputEnabled} ref={childRef} />
                </div>
            )}
            {selectedTypeFile === 'mrcfile' && (
                <div className="font-roboto">
                <ButtonMRCLoad label="Load a mrc file" plugin={props.plugin} setIsInputEnabled={setIsInputEnabled} ref={childRef} />
                </div>
            )}
          </div> 
        )}  
        <div>
        {selectedTypeSource === 'public' && (
            <div id="tourpublic">
            <ButtonStructureLoad color="blue" label="Load" plugin={props.plugin} setIsInputEnabled={setIsInputEnabled} ref={childRef} />
            </div>
        )}
        {selectedTypeSource === 'previousproject' && (
            <div id="tourpreviousproject">
            <ButtonImportState plugin={props.plugin} setIsInputEnabled={setIsInputEnabled} ref={childRef} />
            </div>
        )}
            <div id="toursubmit">
                <div className="mt-4 py-4 border-t-2 border-gray-200">
                <h3 className="text-md font-semibold whitespace-nowrap dark:text-gray-50">EMAIL</h3>
                <small className="text-gray-600 dark:text-gray-50">If you provide your email, you will receive a notification once the InDeep calculation is complete, along with a link to view the results. If you choose not to provide an email, please ensure that you save the link shared with you to access your results later.</small>
                    <div className="py-2">
                        <div className="relative flex">
                            
                            <input
                                type="email"
                                id='email'
                                className="peer h-full w-full rounded-[7px] border border-gray-200 bg-transparent px-3 py-2.5 pr-20 text-sm font-normal text-gray-700 dark:text-gray-50 outline outline-0 transition-all placeholder-shown:border dark:placeholder-shown:border-gray-200 placeholder-shown:border-gray-700 dark:placeholder-shown:border-t-gray-200 placeholder-shown:border-t-gray-700 focus:border-2 dark:focus:border-sky-950 focus:border-sky-950 dark:focus:border-t-transparent focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-gray-50"
                                placeholder=" "
                                required
                            />
                            <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-sky-950 dark:peer-focus:text-sky-950 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:!border-sky-950 dark:peer-focus:before:!border-sky-950 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:!border-sky-950 dark:peer-focus:after:!border-sky-950 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-gray-500">
                                Email address (optional)
                            </label>
                        </div>
                    </div>
                </div>
                <div id="tourcontrolbuttons" className="flex flex-row space-x-4 py-4 justify-center">
                    <ButtonClear plugin={ props.plugin }/>
                    <DisabledSubmitInput {...(selectedTypeFile === 'trajectory' ? { id: 'inputbar-1' } : {})} state={isInputEnabled} handle={handleButtonClick} value='Load Data'/>
                </div>
            </div>
        </div>
        </div>
    )

}
